import { axios } from '../../clients/axios'
import { dayjs, MMDDYYYY } from '../../util/date'

const reservationHeaders = [
  { value: 'refNo', text: 'ID' },
  { value: 'dateCreated', text: 'Date' },
  { value: 'tenantName', text: 'Tenant' },
  { value: 'notes', text: 'Notes' },
  { value: 'moveInDate', text: 'Move In Date' },
  { value: 'status', text: 'Status' },
  { value: 'reservationFee', text: 'Reservation Fee' },
  { value: 'actions', text: 'Actions' }
]

export default {
  namespaced: true,
  state: {
    reservations: [],
    upcomingMoveInReservations: []
  },
  getters: {
    getReservations: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      let parsedReservations = []
      // let reservations = state.reservations
      state.reservations.map((raw) => {
        const alias = aliases.find((a) => a.tenantId === raw.tenantId)
        let reservation = {}
        reservation.reservationId = raw.reservationId
        reservation.refNo = raw.refNo
        reservation.dateCreated = dayjs(raw.dateCreated).format(MMDDYYYY)
        reservation.tenantName = (alias && alias.name) || getTenantName(raw)
        reservation.notes = raw.notes
        reservation.moveInDate = raw.moveInDate
          ? dayjs(raw.moveInDate).format(MMDDYYYY)
          : 'N/A'
        reservation.status = raw.status
        reservation.reservationFee = raw.reservationFee
        reservation.tenantId = raw.tenantId

        parsedReservations.push(reservation)
      })

      return parsedReservations
    },
    getHeaders: () => {
      return reservationHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true

        return header
      })
    }
  },
  mutations: {
    fetchReservations(state, reservations) {
      state.reservations = reservations
    },
    fetchUpcomingMoveInReservations(state, reservations) {
      state.upcomingMoveInReservations = reservations
    }
  },
  actions: {
    async fetchReservationsAction(context, params) {
      const { limit, page } = params
      const reservations = await axios.get(
        `${
          process.env.VUE_APP_API_URL
        }/reservations/search?limit=${limit}&page=${page - 1}`,
        { withCredentials: true }
      )

      context.commit('fetchReservations', reservations.data.data)

      return {
        limit: limit,
        count: reservations.data.count
      }
    },
    async approveReservationAction(context, params) {
      const { reservationId } = params
      const reservation = await axios.put(
        `${process.env.VUE_APP_API_URL}/reservations/${reservationId}/approve`,
        {},
        { withCredentials: true }
      )

      return reservation
    },
    async cancelReservationAction(context, params) {
      const { reservationId } = params
      const reservation = await axios.put(
        `${process.env.VUE_APP_API_URL}/reservations/${reservationId}/cancel`,
        {},
        { withCredentials: true }
      )

      return reservation
    },
    async moveToBedAction(context, params) {
      const {
        reservationId,
        tenantId,
        bedId,
        downPayment,
        daysBeforeNotif,
        contractPeriods,
        firstMonthPaid
      } = params
      try {
        const bed = await axios.put(
          `${process.env.VUE_APP_API_URL}/reservations/${reservationId}/moveToBed`,
          {
            tenantId,
            bedId,
            downPayment,
            daysBeforeNotif,
            contractPeriods,
            firstMonthPaid
          },
          { withCredentials: true }
        )

        return Promise.resolve(bed.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async newReservationAction(context, params) {
      const {
        notes,
        reservationFee,
        moveInDate,
        dateCreated,
        tenantId,
        endDate,
        alias
      } = params
      try {
        const reservation = await axios.post(
          `${process.env.VUE_APP_API_URL}/reservations`,
          {
            notes,
            reservationFee,
            moveInDate,
            dateCreated,
            tenantId,
            endDate,
            alias
          },
          { withCredentials: true }
        )

        return Promise.resolve(reservation)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async editReservationAction(context, params) {
      const {
        notes,
        reservationFee,
        moveInDate,
        dateCreated,
        reservationId,
        endDate
      } = params
      const reservation = await axios.put(
        `${process.env.VUE_APP_API_URL}/reservations/${reservationId}`,
        { notes, reservationFee, moveInDate, dateCreated, endDate },
        { withCredentials: true }
      )

      return reservation
    },
    async fetchUpcomingMoveInReservationAction(context) {
      try {
        const reservations = await axios.get(
          `${process.env.VUE_APP_API_URL}/reservations/upcoming/7`,
          { withCredentials: true }
        )

        context.commit('fetchUpcomingMoveInReservations', reservations.data)

        return Promise.resolve(reservations.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    }
  }
}

const getTenantName = (raw) => {
  if (raw.tenant_details.firstName && raw.tenant_details.lastName) {
    return raw.tenant_details.firstName + ' ' + raw.tenant_details.lastName
  } else {
    return raw.tenant_details.username
  }
}
